import { Modal } from "@design-system/Modal";
import { Text } from "@design-system/Typography/Text";
import { type FC } from "react";
import { useTranslation } from "react-i18next";
import { RESOURCE_NAME, keys } from "../../i18n";

type FilterChangeConfirmationModalProps = {
    open: boolean;
    onOpenChange: (open: boolean) => void;
    onConfirm: () => void;
    onCancel: () => void;
};

export const FilterChangeConfirmationModal: FC<
    FilterChangeConfirmationModalProps
> = ({ open, onOpenChange, onConfirm, onCancel }) => {
    const { t } = useTranslation(RESOURCE_NAME);

    const handleConfirm = () => {
        onConfirm();
    };

    const handleCancel = () => {
        onCancel();
    };

    return (
        <Modal open={open} onOpenChange={onOpenChange}>
            <Modal.Overlay centerContent>
                <Modal.Content className="w-full max-w-xl">
                    <Modal.Header>
                        <Modal.Title>
                            {t(keys.filter_change_confirmation_title)}
                        </Modal.Title>
                    </Modal.Header>
                    <Modal.Body>
                        <Text variant="body" color="primary">
                            {t(keys.filter_change_confirmation_body)}
                        </Text>
                    </Modal.Body>
                    <Modal.Footer>
                        <Modal.CancelCTA onClick={handleCancel}>
                            {t(keys.filter_change_confirmation_cancel)}
                        </Modal.CancelCTA>
                        <Modal.ConfirmCTA onClick={handleConfirm}>
                            {t(keys.filter_change_confirmation_confirm)}
                        </Modal.ConfirmCTA>
                    </Modal.Footer>
                </Modal.Content>
            </Modal.Overlay>
        </Modal>
    );
};
